import React from 'react'
import {IconProps, IconWrapper} from './IconWrapper'
import {Colors} from "../../theme/generated/Colors.ts";

const renderIcon = (color: string) => (
    <path
        d="M12.1665 6.66667H16.3332V2.5M16.0909 13.6308C15.3144 14.8265 14.175 15.7418 12.84 16.2423C11.5049 16.7428 10.0445 16.802 8.6733 16.4114C7.30209 16.0208 6.09246 15.2011 5.22156 14.0723C4.35065 12.9434 3.8647 11.565 3.83484 10.1396C3.80498 8.71412 4.23257 7.31668 5.05544 6.15234C5.87831 4.98801 7.05282 4.11833 8.40648 3.67065C9.76013 3.22298 11.2218 3.22083 12.5766 3.66496C13.9314 4.10909 15.1082 4.97579 15.9341 6.13796"
        stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
)

export const Redo: React.FC<IconProps> = ({color, size}) => <IconWrapper {...{size, color, renderIcon}} viewBox={'0 0 20 20'} />
